export const STEPS = [
  {
    id: "intro",
    title: "Getting Started",
    description: "Introduction and overview",
    question: null,
  },
  {
    id: "notes",
    title: "Notes",
    description: "Add Notes From Previous Planning",
    question: "By adding notes you improve context and generate more personalized reports.",
  },
  {
    id: "document-vault",
    title: "Document Vault",
    description: "Store and manage your documents",
    question: null,
  },
  {
    id: "personal-information",
    title: "Personal Information",
    description: "Name, address, etc.",
    question: null,
  },
  {
    id: "immediate-family",
    title: "Family Relationships",
    description: "Your relationships and children",
    question: null,
  },
  {
    id: "estate-roles",
    title: "Estate Roles",
    description: "Add Executor, Power of Attorney, Etc",
    question:
      "Add key people to your estate like your Executor, Power of Attorney, Trust, Guardian, Pet Caretaker, Financial Advisor, Tax Professional, Legal Professional, Etc.",
  },
  {
    id: "real-estate",
    title: "Real Estate",
    description: "Add your real estate properties",
    question: "Do you own your primary residence?",
  },
  {
    id: "retirement-savings",
    title: "Retirement Savings",
    description: "Retirement accounts and plans",
    question: "Do you have a retirement savings account?",
  },
  {
    id: "vehicle",
    title: "Vehicle",
    description: "Cars, boats, planes, or other vehicles",
    question: "Do you own a car, boat, plane, or any other vehicle?",
  },
  {
    id: "additional-assets",
    title: "Additional Assets",
    description: "Add other investments & currencies",
    question:
      "Add additional assets like savings accounts, chequing accounts, stocks, bonds, precious metals, currency, cryptocurrency, family heirlooms, personal items, etc.",
  },
  {
    id: "private-company",
    title: "Companies",
    description: "Manage Companies Within The Estate",
    question: "Organise all companies within the estate",
  },
  {
    id: "trust",
    title: "Trust",
    description: "Add current or future trust",
    question: "Do you have a trust set up for beneficiaries?",
  },
  {
    id: "insurance",
    title: "Insurance",
    description: "Provide your insurance details",
    question: "Do you have life insurance?",
  },
  {
    id: "beneficiaries",
    title: "Beneficiaries",
    description: "List of beneficiaries",
    question: null,
  },
  {
    id: "asset-ownership",
    title: "Asset Ownership",
    description: "Review and set ownership types for your assets",
    question:
      "Review each asset and set the ownership type to determine how it will be handled in your estate.",
  },
  {
    id: "funeral-arrangements",
    title: "Funeral Arrangements",
    description: "Your funeral preferences",
    question: "Outline your preferred funeral arrangements",
  },
  {
    id: "personal-care",
    title: "Personal Care",
    description: "Share your care preferences in case of incapacity",
    question: "",
  },
  {
    id: "organize-journal",
    title: "Organize Journal",
    description: "Manage your journal",
    question: null,
  },
] as const
